'use client';

import { Link } from '@payloadcms/ui';
import { usePathname } from 'next/navigation';

import './nav-link.scss';

import type { ReactNode } from 'react';

interface NavLinkProps {
  badge?: ReactNode;
  href: string;
  icon: ReactNode;
  label: string;
}

export const NavLink = ({ badge, href, icon, label }: NavLinkProps) => {
  const isActive = usePathname()?.startsWith(href) === true;

  return (
    <Link className={`nav__link fv-nav-link${isActive ? ' is-active' : ''}`} href={href}>
      {isActive && <div className="nav__link-indicator" />}
      {icon}
      <span className="nav__link-label">{label}</span>
      {badge}
    </Link>
  );
};
